<template>
  <div class="pt-4">
    <h3 class="text-subtitle-1">
      by
      <v-dialog
        v-if="
          photo.statusName !== types.photo.status.inCuration ||
            me.isAdmin ||
            me.role === types.user.role.curator
        "
        v-model="photographerDialog"
        width="300"
      >
        <template #activator="{ on }">
          <span class="pointer text-underline font-weight-bold" v-on="on">
            {{ photo.photographerName }}
          </span>
        </template>
        <PhotographerModal :me="me" :photo="photo" :info="info" />
      </v-dialog>
      <v-tooltip v-else top max-width="300">
        <template #activator="{ on }">
          <span class="font-weight-bold" v-on="on">Hidden Name</span>
        </template>
        <span>
          Photographer's name will be visible at the end of the curation period
        </span>
      </v-tooltip>
    </h3>
    <h4
      v-if="photo.statusName === types.photo.status.inCuration"
      class="text-subtitle-2"
    >
      Uploaded for
      <span class="font-weight-bold">curation</span>
      {{ photo.uploadDate | timeago }}
    </h4>
    <h4 class="text-caption">
      Category:
      <span small class="font-weight-bold text-uppercase" text>
        {{ photo.categoryName }}
      </span>
    </h4>
    <h5 v-if="photo.city && photo.country" class="text-caption">
      Location:
      <v-dialog
        ref="dialog"
        v-model="locationDialog"
        width="600"
        @input="isLocationDialogVisible"
      >
        <template #activator="{ on: dialog }">
          <v-tooltip top>
            <template #activator="{ on: tooltip }">
              <span
                small
                class="font-weight-bold text-uppercase link"
                text
                v-on="{ ...dialog, ...tooltip }"
              >
                {{ photo.city }} - {{ photo.country }}
              </span>
            </template>
            <span>
              View photo location on map
            </span>
          </v-tooltip>
        </template>
        <v-card outlined>
          <v-card-text class="pt-6">
            <div id="map" class="map"></div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </h5>
    <h5 v-if="photo.isCreativeEdit" class="text-caption mb-4 font-weight-bold">
      Creative Edit
    </h5>
    <div class="mt-4">
      <p>{{ photo.description }}</p>
    </div>
    <div v-if="photo && photo.tags && photo.tags.length > 0" class="my-6">
      <h5 class="text-body-1 d-block font-weight-bold">
        Tagged as:
      </h5>
      <span
        v-for="(tag, i) in photo.tags"
        :key="i"
        class="text-body-2 no-underline font-italic d-inline-block mr-2"
      >
        #{{ tag }}
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { photoLocationDialogMixin } from '@/mixins/photoLocationDialogMixin'
import types from '@/utils/types'

export default {
  name: 'CurationPanelInformation',
  filters: {
    timeago: date => {
      return moment
        .utc(date)
        .local()
        .fromNow()
    }
  },
  components: {
    PhotographerModal: () => import('@/components/photo/PhotographerModal.vue')
  },
  mixins: [photoLocationDialogMixin],
  props: {
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    photo: {
      type: Object,
      default: () => {}
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      types,
      photographerDialog: false
    }
  }
}
</script>

<style scoped>
.link {
  cursor: pointer;
  text-decoration: underline;
}
.map {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 300px;
}
</style>
